// extracted by mini-css-extract-plugin
export default {"info":"info_info__y95s0","orange":"info_orange__3I-VN","arrow":"info_arrow__jwply","blue":"info_blue__nTqBj"};